import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/login", form);
      const tab = params.get("tab");
      nav(tab ? `/admin?tab=${encodeURIComponent(tab)}` : "/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#141412] px-5 grain" data-testid="admin-login-page">
      <div className="relative w-full max-w-md">
        <Link to="/" data-testid="admin-login-home-link"><Logo /></Link>
        <form onSubmit={submit} className="mt-10 rounded-[28px] bg-[#FAF8F5] p-8 sm:p-10" data-testid="admin-login-form">
          <h1 className="font-display text-4xl font-bold">Admin portal</h1>
          <p className="mt-2 text-sm text-stone-600">Sign in to manage enquiries, subscriptions, orders and chef applications.</p>
          <div className="mt-8 space-y-4">
            <div>
              <label className="label">Email</label>
              <input required type="email" className="field" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email-input" />
            </div>
            <div>
              <label className="label">Password</label>
              <input required type="password" className="field" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password-input" />
            </div>
            {err && <p className="text-sm text-red-700" data-testid="admin-login-error">{err}</p>}
            <button disabled={busy} className="btn-ink w-full justify-center" data-testid="admin-login-submit">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
